module.exports = __webpack_public_path__ + "static/media/66.ba9d9ed2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/66.jpg
// module id = 1005
// module chunks = 0